import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import styles from "./styles";
import { useEffect, useState } from "react";
import {
  getApi,
  postApiWithAuth,
  postApiWithAuthFormData,
} from "../../utils/apis";
import { getApiErrorMessage } from "../../utils/commonHelpers";
import getAPIUrl from "../../config";
import { IUser } from "../Users/types";
import { array, object, string, z } from "zod";
import { IParcelFormData, IParcelImage, ParcelStatus } from "./types";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import InputField from "../../components/InputField";
import CustomSelect from "../../components/SelectField";
import CameraIcon from "../../assets/camera.svg";
import { IPicker } from "../Pickers/types";
import TrashIcon from "../../assets/trash.svg";
import toastStyles from "../../components/Toast/styles";
import Toast from "../../components/Toast";
import Header from "../Header";
import CustomAutoComplete from "../../components/AutoComplete";
import { useTranslation } from "react-i18next";

const AddParcel = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [errorToast, setErrorToast] = useState<boolean>(false);
  const [toastErrorMsg, setErrorToastMsg] = useState<string>("");
  const [successToast, setSuccessToast] = useState<boolean>(false);
  const [toastSuccessMsg, setSuccessToastMsg] = useState<string>("");
  const [pickupLocations, setPickupLocations] = useState<IPicker[]>([]);
  const [users, setUsers] = useState<IUser[]>([]);
  const [userId, setUserId] = useState<string>("");

  const navigate = useNavigate();
  const { t } = useTranslation();

  const validationSchema = object({
    pickupLocationId: string().min(1, "Please select pickup location"),
    userId: string().min(1, "Please select User"),
    deliveryCompany: string().min(1, {
      message: "Please add delivery company",
    }),
    parcelStatus: z.enum([
      ParcelStatus.InStorage,
      ParcelStatus.Issued,
      ParcelStatus.Returned,
    ]),
    parcelImage: array(object({ name: string(), imageUrl: string() })),
    parcelImages: array(
      z.instanceof(File, { message: "Please upload profile pic" })
    ),
  });

  const defaultValues: IParcelFormData = {
    pickupLocationId: "",
    userId: "",
    deliveryCompany: "",
    parcelStatus: ParcelStatus.InStorage,
    parcelImage: [
      {
        name: "",
        imageUrl: "",
      },
    ],
    parcelImages: [],
  };

  const {
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
    watch,
  } = useForm({
    defaultValues: defaultValues,
    resolver: zodResolver(validationSchema),
  });

  const handleCancel = () => {
    reset(defaultValues);
    navigate("/parcels");
  };

  const uploadFiles = async (filesToUpload: File[]) => {
    try {
      const formData = new FormData();
      filesToUpload.map((rec) => formData.append("files", rec));

      const res = await postApiWithAuthFormData(
        `${getAPIUrl()}/api/v1/files/parcel-images`,
        formData
      );
      return res.data;
    } catch (error) {
      if (error instanceof Error) {
        const errorMsg = getApiErrorMessage(error);
        setErrorToastMsg(errorMsg);
        setErrorToast(true);
      }
    }
  };

  const onSubmit = handleSubmit(async (data) => {
    setLoading(true);
    let updatedImages: IParcelImage[] = [];
    const { parcelImages, ...rest } = data;
    if (data.parcelImages.length) {
      const uploadedImages: IParcelImage[] = await uploadFiles(parcelImages);
      updatedImages = uploadedImages.map((rec) => ({
        name: rec.name,
        imageUrl: rec.imageUrl,
      }));
    }
    try {
      await postApiWithAuth(`${getAPIUrl()}/api/v1/parcels`, {
        ...rest,
        parcelImage: updatedImages,
      });

      setSuccessToastMsg("Parcel created successfully");
      setSuccessToast(true);
      reset(defaultValues);
      setTimeout(() => {
        setLoading(false);
        navigate("/parcels");
      }, 1000);
    } catch (error) {
      if (error instanceof Error) {
        const errorMsg = getApiErrorMessage(error);
        setErrorToastMsg(errorMsg);
        setErrorToast(true);
        setLoading(false);
      }
    }
  });

  useEffect(() => {
    const getUsers = async () => {
      try {
        const usersData = await getApi(
          `${getAPIUrl()}/api/v1/users/name?roleName=Picker`
        );
        console.log("usersData", usersData);
       // setUsers(usersData.data);
        //setLoading(false);
      } catch (error) {
        if (error instanceof Error) {
          const errorMsg = getApiErrorMessage(error);
          setErrorToast(true);
          setErrorToastMsg(errorMsg);
        }
      }
     };
  //   const getUsers = async () => {
  //     try {
  //         const pickupLocations = await getApi(
  //             `${getAPIUrl()}/api/v1/pickup-locations`
  //         );
  //         const users = pickupLocations.data.map((location: any) => location.user);
  //         setUsers(users);
  //         setLoading(false);
  //     } catch (error) {
  //         if (error instanceof Error) {
  //             const errorMsg = getApiErrorMessage(error);
  //             setErrorToast(true);
  //             setErrorToastMsg(errorMsg);
  //         }
  //     }
  // };
    const getLocations = async () => {
      try {
        const locationsData = await getApi(
          `${getAPIUrl()}/api/v1/pickup-locations`
        );
        console.log("locationsData", locationsData);
        setPickupLocations(locationsData.data.data);
        const users = locationsData.data.data.map((location: any) => location.user);
        console.log ("users", users);
        setUsers(users);
        setLoading(false);
      } catch (error) {
        if (error instanceof Error) {
          const errorMsg = getApiErrorMessage(error);
          setErrorToast(true);
          setErrorToastMsg(errorMsg);
        }
      }
    };

    getUsers();
    getLocations();
  }, []);

  const usersList =
    users &&
    users.map((user) => ({
      value: user.id,
      name: `${user.firstName} ${user.lastName}`,
    }));


  const pickupLocationList =
    pickupLocations &&
    pickupLocations
      .filter((rec) => rec.userId === userId)
      .map((loc) => ({
        name: loc.location.name,
        value: loc.id,
      }));

  const parcelStatusesList = Object.entries(ParcelStatus).map((rec) => ({
    name: rec[0],
    value: rec[1],
  }));

  const watchFields = watch(["userId", "parcelImages"]);

  return (
    <Grid sx={styles.container}>
      <Header
        name={t("newParcel")}
        setErrorToast={setErrorToast}
        setSuccessToast={setSuccessToast}
        setErrorToastMsg={setErrorToastMsg}
        setSuccessToastMsg={setSuccessToastMsg}
      />
      <Box sx={styles.parcelDetailsContainer}>
        <Typography sx={styles.subHeading}>{t("parcelDetails")}</Typography>
        {loading ? (
          <Typography sx={styles.spinner} data-testId="loader">
            <CircularProgress />
          </Typography>
        ) : (
          <Box component="form" sx={styles.formContainer} onSubmit={onSubmit}>
            <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 10 }}>
              <Grid item md={6} xs={12}>
                <Controller
                  name="userId"
                  control={control}
                  render={({ field }) => (
                    <CustomAutoComplete
                      id="userId"
                      placeholder={t("user")}
                      items={usersList}
                      value={usersList.find((pt) => pt.value === field.value) || null}
                      options={usersList}
                      size="small"
                      renderInput={(para) => {
                        return <TextField {...para} />;
                      }}
                      onChange={(_e, selected) => {
                        field.onChange(selected?.value ?? "");
                        const uId = selected?.value.toString() ?? "";
                        setUserId(uId);
                        //setPickupLocations([]);
                      }}
                      fullWidth
                      sx={styles.select_field}
                      errorMessage={errors.userId?.message}
                      label={t("user")}
                    />
                  )}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <Controller
                  name="pickupLocationId"
                  control={control}
                  render={({ field }) => (
                    <CustomAutoComplete
                      id="pickupLocationId"
                      placeholder={t("pickupLocation")}
                      items={pickupLocationList}
                      value={pickupLocationList.find((pt) => pt.value === field.value) || null}
                      options={pickupLocationList}
                      size="small"
                      renderInput={(para) => {
                        return <TextField {...para} />;
                      }}
                      onChange={(_e, selected) => {
                        field.onChange(selected?.value ?? "");
                      }}
                      fullWidth
                      sx={styles.select_field}
                      errorMessage={errors.pickupLocationId?.message}
                      label={t("pickupLocation")}
                    />
                  )}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Controller
                  name="deliveryCompany"
                  control={control}
                  render={({ field }) => (
                    <InputField
                      {...field}
                      id="deliveryCompany"
                      label={t("deliveryCompany")}
                      placeholder={t("deliveryCompany")}
                      type="text"
                      showCross
                      fullWidth
                      size="small"
                      handleCrossClick={() => setValue("deliveryCompany", "")}
                      error={!!errors.deliveryCompany?.message}
                      errorMessage={errors.deliveryCompany?.message}
                    />
                  )}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <Controller
                  name="parcelStatus"
                  control={control}
                  render={({ field }) => (
                    <CustomSelect
                      {...field}
                      id="parcelStatus"
                      onChange={(e) => field.onChange(e.target.value)}
                      size="small"
                      fullWidth
                      placeholder={t("status")}
                      items={parcelStatusesList}
                      error={!!errors.parcelStatus?.message}
                      errorMessage={errors.parcelStatus?.message}
                      label={t("status")}
                      disabled
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid item md={6} xs={12}>
              <Controller
                name="parcelImages"
                control={control}
                render={({ field }) => (
                  <Button
                    component="label"
                    startIcon={
                      <img src={CameraIcon} alt="" style={styles.trashIcon} />
                    }
                    sx={styles.addImageButton}
                  >
                    Add photo from drive
                    <input
                      type="file"
                      id="upload-profile-picture"
                      accept=".png,.jpg,.jpeg"
                      hidden
                      multiple
                      onChange={(e) =>
                        field.onChange(
                          e.target.files && [
                            ...field.value,
                            ...Array.from(e.target.files as FileList),
                          ]
                        )
                      }
                    />
                  </Button>
                )}
              />
            </Grid>

            {watchFields[1].length ? (
              <Box sx={styles.addedImagesContainer}>
                {watchFields[1].map((rec, index) => (
                  <Stack
                    key={index}
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={styles.addedImageContainer}
                  >
                    <Grid sx={styles.imageGrid}>
                      <img
                        alt={`parcel-${index}`}
                        src={URL.createObjectURL(rec)}
                        style={styles.addedImage}
                      />
                      <Grid>
                        <Typography sx={styles.imageName}>
                          {rec.name}
                        </Typography>
                        <Typography sx={styles.imageSize}>
                          {`${(rec.size / (1024 * 1024)).toFixed(2)} MB`}
                        </Typography>
                      </Grid>
                    </Grid>
                    <img
                      alt=""
                      src={TrashIcon}
                      style={styles.trashIcon}
                      onClick={() =>
                        setValue(
                          "parcelImages",
                          watchFields[1].filter((it) => it !== rec)
                        )
                      }
                    />
                  </Stack>
                ))}
              </Box>
            ) : undefined}

            <Grid
              container
              rowSpacing={2}
              columnSpacing={{ xs: 1, sm: 10 }}
              sx={styles.buttonsGrid}
            >
              <Grid item md={6} xs={12}>
                <Button
                  variant="outlined"
                  fullWidth
                  sx={styles.cancelButton}
                  onClick={handleCancel}
                >
                   {t("cancel")}
                </Button>
              </Grid>

              <Grid item md={6} xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={styles.saveButton}
                >
                   {t("save")}
                </Button>
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
      <Toast
        id="add-parcel-success"
        open={successToast}
        message={toastSuccessMsg}
        severity="success"
        onClose={() => setSuccessToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        alertStyles={toastStyles.toastText}
      />
      <Toast
        id="add-parcel-error"
        open={errorToast}
        message={toastErrorMsg}
        severity="error"
        onClose={() => setErrorToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        alertStyles={toastStyles.toastText}
      />
    </Grid>
  );
};

export default AddParcel;
